/* eslint-disable react/prop-types */
import React from 'react';
import { Link } from 'react-router-dom';
// import DropdownMessage from './DropdownMessage';
// import DropdownNotification from './DropdownNotification';
import DropdownUser from './DropdownUser';
import LogoIcon from '../../images/logo/gitme-logo.svg';
import LogoIconWhite from '../../images/logo/gitme-logo-white.svg';
import DarkModeSwitcher from './DarkModeSwitcher';
import AnalysisStatusChip from './AnalysisStatusChip';
import SetupProgressHeader from '../SetupProgressHeader';

const Header = props => {
  return (
    <header className="z-999 w-full border-b border-stroke/70 bg-white/95 backdrop-blur-md dark:border-strokedark dark:bg-boxdark/95">
      <div className="px-4 py-4 md:px-6 2xl:px-11">
        <div className="flex flex-wrap items-center justify-between gap-4">
          <div className="order-1 flex min-w-0 flex-1 items-center gap-2 sm:gap-4 lg:flex-none">
            {/* <!-- Hamburger Toggle BTN --> */}
            <button
              aria-controls="sidebar"
              onClick={e => {
                e.stopPropagation();
                props.setSidebarOpen(!props.sidebarOpen);
              }}
              className="z-99999 block rounded-sm border border-stroke bg-white p-1.5 shadow-sm dark:border-strokedark dark:bg-boxdark lg:hidden"
            >
              <span className="relative block h-5.5 w-5.5 cursor-pointer">
                <span className="du-block absolute right-0 h-full w-full">
                  <span
                    className={`relative left-0 top-0 my-1 block h-0.5 w-0 rounded-sm bg-black delay-[0] duration-200 ease-in-out dark:bg-white ${
                      !props.sidebarOpen && '!w-full delay-300'
                    }`}
                  ></span>
                  <span
                    className={`relative left-0 top-0 my-1 block h-0.5 w-0 rounded-sm bg-black delay-150 duration-200 ease-in-out dark:bg-white ${
                      !props.sidebarOpen && 'delay-400 !w-full'
                    }`}
                  ></span>
                  <span
                    className={`relative left-0 top-0 my-1 block h-0.5 w-0 rounded-sm bg-black delay-200 duration-200 ease-in-out dark:bg-white ${
                      !props.sidebarOpen && '!w-full delay-500'
                    }`}
                  ></span>
                </span>
                <span className="absolute right-0 h-full w-full rotate-45">
                  <span
                    className={`absolute left-2.5 top-0 block h-full w-0.5 rounded-sm bg-black delay-300 duration-200 ease-in-out dark:bg-white ${
                      !props.sidebarOpen && '!h-0 !delay-[0]'
                    }`}
                  ></span>
                  <span
                    className={`delay-400 absolute left-0 top-2.5 block h-0.5 w-full rounded-sm bg-black duration-200 ease-in-out dark:bg-white ${
                      !props.sidebarOpen && '!h-0 !delay-200'
                    }`}
                  ></span>
                </span>
              </span>
            </button>
            {/* <!-- Hamburger Toggle BTN --> */}

            <Link className="block flex-shrink-0 lg:hidden" to="/">
              <>
                <img
                  className="dark:hidden"
                  src={LogoIcon}
                  alt="Logo"
                  width={100}
                />
                <img
                  className="hidden dark:block"
                  src={LogoIconWhite}
                  alt="Logo"
                  width={100}
                />
              </>
            </Link>
          </div>

          <div className="hidden lg:block">
            <Link className="block flex-shrink-0" to="/">
              <>
                <img
                  className="dark:hidden"
                  src={LogoIcon}
                  alt="Logo"
                  width={120}
                />
                <img
                  className="hidden dark:block"
                  src={LogoIconWhite}
                  alt="Logo"
                  width={120}
                />
              </>
            </Link>
          </div>

          <div className="order-3 flex basis-full justify-center px-0 sm:px-2 lg:order-2 lg:basis-auto lg:flex-1 lg:px-4">
            <div className="flex w-full min-w-0 max-w-[720px] flex-col items-center gap-2">
              {props.showSetupProgress && <SetupProgressHeader />}
            </div>
          </div>

          <div className="order-2 flex items-center gap-3 2xsm:gap-7">
            <ul className="flex items-center gap-2 2xsm:gap-4">
              {/* <!-- Dark Mode Toggler --> */}
              <DarkModeSwitcher />
              {/* <!-- Dark Mode Toggler --> */}

              {/* <!-- Notification Menu Area -->  */}
              {/* <DropdownNotification />*/}

              {/* <!-- Notification Menu Area --> */}

              {/* <!-- Chat Notification Area --> */}
              {/* <!--  <DropdownMessage /> --> */}

              {/* <!-- Chat Notification Area --> */}
            </ul>

            <AnalysisStatusChip />

            {/* <!-- User Area --> */}
            <DropdownUser />
            {/* <!-- User Area --> */}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
